import VSubmenu from '../menu/v-submenu.vue';

export default VSubmenu;